import React from 'react';
import SharedAdditionalInformation from '../../../shared/AdditionalInformation';
import { VouIdCode } from '@src/store/enums';
import PropTypes from 'prop-types';

const AdditionalInformation = ({ form, sendFormToParentPage = null }) => (
  <SharedAdditionalInformation
    form={form}
    sendFormToParentPage={sendFormToParentPage}
    vouId={VouIdCode.Market}
    callSendOnInit={true}
  />
);

AdditionalInformation.propTypes = {
  form: PropTypes.any,
  sendFormToParentPage: PropTypes.func,
};

export default AdditionalInformation;
